import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import * as eventActions from '../../actions/event-actions';
import { fetchComponentConfig } from '../../actions/component-config-actions';
import ScheduleTabContent from '../../components/EventProfile/ScheduleTabContent';
import { fetchAuthenticatedUser, setAuthHeader } from '../../actions';

const WebViewEventSchedule = (props) => {
    const parsed = queryString.parse(props.location.search);
    const { jwt } = parsed;
    if (jwt) {
        props.setAuthHeader({ jwt });
    }

    const event = props.events.currentEvent.data;
    //  TODO: this error is never used, wire this up.
    // eslint-disable-next-line
    const [error, setError] = useState();

    const getEvent = async () => {
        await props.getEvent(props.match.params.eventId);
        if (props.events.currentEvent.error) {
            setError(true);
        }
    };

    useEffect(() => {
        props.getComponentConfig(props.match.params.eventId);
    }, []);

    useEffect(() => {
        (async () => {
            await props.fetchAuthenticatedUser();
        })();
    }, []);

    useEffect(() => {
        // eslint-disable-next-line eqeqeq
        if (props.auth?.user?.id && !props.events.currentEvent.isLoading && props.events.currentEvent.data?.id != props.match.params.eventId) {
            getEvent();
        }
    }, [props.events.currentEvent.data, props.events.currentEvent.isLoading, props.auth?.user?.id]);

    return (event ? (
        <div className="p24" data-testid="webview.event-schedule.container">
            <ScheduleTabContent
                scheduleType={event.scheduleType?.value}
                data-testid="webview.event-schedule.schedule-content"
            />
        </div>
    ) : null);
};

function mapDispatchToProps(dispatch) {
    return {
        getEvent: (eventId) => {
            return dispatch(eventActions.getEvent(eventId, false, false, false, false));
        },
        getComponentConfig: (eventId) => {
            return dispatch(fetchComponentConfig('event-profile', { eventId }));
        },
        setAuthHeader: ({ jwt }) => {
            return dispatch(setAuthHeader({ jwt }));
        },
        fetchAuthenticatedUser: () => {
            return dispatch(fetchAuthenticatedUser());
        },
    };
}

function mapStateToProps({ events, auth }) {
    return { events, auth };
}

const component = connect(mapStateToProps, mapDispatchToProps)(WebViewEventSchedule);

export default {
    component,
    loadData: ({ dispatch }, match) => {
        dispatch(eventActions.getEventMetaData(match.params.eventId));
        dispatch(eventActions.getEvent(match.params.eventId, false, false, false, false));
    },
};
